export default "__VITE_ASSET__CGwnq0qO__"